import * as React from "react";
import styles from "./styles.module.sass";
import { useCallback } from "react";
import { Tooltip } from "antd";
import ClockCircleOutlined from "@ant-design/icons/lib/icons/ClockCircleOutlined";
import { useTranslation } from "../../../../../shopx-shared-components/hooks/useTranslation";
import Strings from "../../../../../i18n/strings/serviceDisableModal";
import BranchStrings from "../../../../../i18n/strings/branches";
import { useCanUseDriveThruOrdering } from "../../../../../hooks/use-can-use-drive-thru-ordering";
import useRenderPosName from "../../../../../hooks/use-render-pos-name";
import { ServiceType } from "../../../../../types/audit";
import i18n from "../../../../../i18n/i18n";

export interface ISelectItemProps {
  activePickup: boolean;
  activeDriveThru?: boolean;
  activeDelivery: boolean;
  scheduledPickup?: boolean;
  scheduledDelivery?: boolean;
  scheduledDriveThru?: boolean;
  pos_vendor?: string;
  pos_name?: string;
  item: { name: string; value: string; style?: React.CSSProperties };
  onClick: (
    item: { name: string; value: string },
    type: string,
    newVal: boolean
  ) => void;
  onScheduledClick?: (serviceType: ServiceType) => void;
}

interface ServiceCheckboxProps {
  active: boolean;
  scheduled?: boolean;
  disabled?: boolean;
  positionClass: string;
  onClick: () => void;
  onScheduledClick?: () => void;
}

const ServiceCheckbox: React.FC<ServiceCheckboxProps> = ({
  active,
  scheduled,
  disabled,
  positionClass,
  onClick,
  onScheduledClick,
}) => {
  const { t } = useTranslation("serviceDisableModal");

  const handleClick = (e: React.MouseEvent) => {
    if (scheduled && onScheduledClick) {
      e.stopPropagation();
      onScheduledClick();
      return;
    }
    if (!disabled) {
      onClick();
    }
  };

  const handleClockClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onScheduledClick?.();
  };

  return (
    <div className={styles.checkboxContainer}>
      <div
        className={`${styles.checkBox} ${active ? styles.activePickup : ""} ${
          scheduled ? styles.scheduled : ""
        } ${disabled ? styles.disable : ""} ${positionClass}`}
        onClick={handleClick}
      >
        {!scheduled && <img src={require("../../../assets/path.svg").default} alt="" />}
        {scheduled && (
          <Tooltip
            title={t(Strings.scheduledDisableTooltip)}
            getPopupContainer={() => document.body}
          >
            <span className={styles.clockIcon} onClick={handleClockClick}>
              <ClockCircleOutlined />
            </span>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export const SelectItem: React.FC<ISelectItemProps> = (props) => {
  const {
    item,
    activeDelivery,
    activePickup,
    onClick,
    activeDriveThru,
    pos_name,
    scheduledPickup,
    scheduledDelivery,
    scheduledDriveThru,
    onScheduledClick,
  } = props;
  const canUseDriveThruOrdering = useCanUseDriveThruOrdering();
  const renderedPosName = useRenderPosName(pos_name);

  const handlePickupClick = useCallback(() => {
    onClick(item, "Pickup", !activePickup);
  }, [onClick, item, activePickup]);

  const handleDeliveryClick = useCallback(() => {
    onClick(item, "Delivery", !activeDelivery);
  }, [onClick, item, activeDelivery]);

  const handleDriveThruClick = useCallback(() => {
    onClick(item, "DriveThru", !activeDriveThru);
  }, [onClick, item, activeDriveThru]);

  return (
    <div
      className={`${styles.main} ${
        activeDelivery || activePickup ? styles.active : ""
      }`}
    >
      <div className={styles.text} style={item.style}>
        {item.name} {renderedPosName}
      </div>
      <div className={styles.checkBoxWrapper}>
        <ServiceCheckbox
          active={activePickup}
          scheduled={scheduledPickup}
          positionClass={styles.leftCheckBox}
          onClick={handlePickupClick}
          onScheduledClick={() => onScheduledClick?.("pickup")}
        />
        {canUseDriveThruOrdering && (
          <Tooltip
            title={
              !activePickup
                ? i18n.t(BranchStrings.driveThruEnableHint, { ns: "branches" })
                : undefined
            }
            getPopupContainer={() => document.body}
          >
            <span style={{ display: "inline-flex" }}>
              <ServiceCheckbox
                active={!!activeDriveThru}
                scheduled={scheduledDriveThru}
                positionClass={styles.leftCheckBox}
                onClick={handleDriveThruClick}
                onScheduledClick={() => onScheduledClick?.("drive_thru")}
              />
            </span>
          </Tooltip>
        )}
        <ServiceCheckbox
          active={activeDelivery}
          scheduled={scheduledDelivery}
          positionClass={styles.rightCheckBox}
          onClick={handleDeliveryClick}
          onScheduledClick={() => onScheduledClick?.("delivery")}
        />
      </div>
    </div>
  );
};
